import { InputHTMLAttributes } from "react";
import SearchIcon from "../../../../shared/assets/icons/search.svg";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, ...props }: InputProps) {
  return (
    <div
      className={[
        "relative bg-transparent border border-antique-brass-500 rounded-tl-md rounded-br-md has-[:focus]:border-b-2 mb-[1px] has-[:focus]:mb-0",
        className,
      ].join(" ")}
    >
      <input
        className={
          "w-full h-full bg-transparent text-antique-brass-500 text-lg placeholder-antique-brass-500 py-2 ps-4 pe-10 outline-none"
        }
        placeholder={"Pesquisar"}
        {...props}
      />

      <SearchIcon
        className={"absolute w-6 aspect-square right-2 top-0 bottom-0 my-auto"}
      />
    </div>
  );
}
